import { render, staticRenderFns } from "./BudgetAccountDetails.vue?vue&type=template&id=a5d6dc38&scoped=true&"
import script from "./BudgetAccountDetails.vue?vue&type=script&lang=js&"
export * from "./BudgetAccountDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5d6dc38",
  null
  
)

export default component.exports